'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, $filterSelectedButton) {
    var $results = $(response);

    if (!$results.length || !$results[0]) {
        return;
    }

    var isNoResultsResponse = $results[0].className === 'search-no-results';

    if (isNoResultsResponse) {
        $('.filter-button-and-sort-order-mobile .sort-order').addClass('d-none');

        if ($filterSelectedButton && $filterSelectedButton.length) {
            $filterSelectedButton.find('i').removeClass("fa-check-square-o").addClass("fa-square-o");
            var attributeID = $filterSelectedButton.find('.refinementAttributeID').val();
            var dataHrefArray = $filterSelectedButton.data('href').split('&');
            var sameAttributeURLPiece = dataHrefArray.filter(function (piece) {
                return piece.indexOf(attributeID) > 0;
            })[0];

            var sameAttributeURLIndexString = sameAttributeURLPiece.split("=")[0];
            var sameAttributeURLIndex = sameAttributeURLIndexString[sameAttributeURLIndexString.length - 1];
            var attributeValuesURLIndex = dataHrefArray.findIndex(function (el) {
                return el.includes('prefv' + sameAttributeURLIndex);
            });
            var selectedButtonValue = $filterSelectedButton.find('.refinement-value-displayValue').text().trim();
            dataHrefArray[attributeValuesURLIndex] = dataHrefArray[attributeValuesURLIndex].concat("%7c" + selectedButtonValue);

            var finalHref = dataHrefArray.join('&');

            $filterSelectedButton.data('href', finalHref);
            $filterSelectedButton.attr('data-href', finalHref);

            $('.refinenement-value-button').each(function (index) {
                var $button = $($('.refinenement-value-button')[index]);
                if ($filterSelectedButton[0] != $button[0]) {
                    var buttonDataHref = $button.data('href');
                    var newHref = buttonDataHref.replace(selectedButtonValue, '');
                    $button.data('href', newHref);
                    $button.attr('data-href', newHref);
                }
            });
        }

        $('.product-grid').empty().append($results[0]);
        return;
    } else {
        $('.filter-button-and-sort-order-mobile .sort-order').removeClass('d-none');
    }

    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.sort-order'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function pushURL(refinementURL) {
    if (!refinementURL) {
        return;
    }

    var nextUrl = refinementURL.replace("ShowAjax", "Show");

    try {
        var parsed = new URL(nextUrl, window.location.href);

        history.pushState(null, "", parsed.pathname + parsed.search + parsed.hash);
    } catch (e) {
        // Ignore invalid history URLs
    }
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.js-refinements-modal').toggleClass("show");
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('body').css("position", "fixed");
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.js-refinements-close, .modal-background', function () {
            $('.js-refinements-modal').toggleClass("show");
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('body').css("position", "");
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            var sortOrderSelect = this;
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid-products').empty().html(response);
                    var url = new URL(window.location.href);
                    var selectedSortOption = sortOrderSelect.options[sortOrderSelect.selectedIndex].dataset.id;
                    url.searchParams.set('srule', selectedSortOption);
                    window.history.pushState(null, '', url);
                    var refinementURL;
                    var params;
                    $('.refinenement-value-button').each(function () {
                        refinementURL = $(this).data('href');
                        params = new URLSearchParams(refinementURL.split('?')[1]);
                        params.set('srule', selectedSortOption);
                        $(this).attr('data-href', refinementURL.split('?')[0] + '?' + params.toString());
                        $(this).data('href', refinementURL.split('?')[0] + '?' + params.toString());
                    });

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var attributeId = '#' + $(this).find('span').last().attr('id');

                var refinementURL = $(this).data('href');

                $.ajax({
                    url: refinementURL,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: refinementURL
                    },
                    method: 'GET',
                    context: this,
                    success: function (response) {
                        parseResults(response, $(this));
                        pushURL(refinementURL);
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('button').focus();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    openSelectedRefinementsTab: function () {
        var $cardParent;
        $('.selected').each(function () {
            $cardParent = $(this).parents('.card');
            if (!$cardParent.hasClass('active')) {
                $cardParent.find('.card-header').find('button').trigger('click');
            }
        });
    },

    helpers: {
        parseResults: parseResults,
        pushURL: pushURL
    }
};
